// extracted by mini-css-extract-plugin
export default {"rootContainer":"app_rootContainer__HSSCw"};